"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var itemsList_1 = require("../itemsList");
var react_transition_group_1 = require("react-transition-group");
var loader_1 = require("../loader");
var index_1 = require("../index");
var CLOSE_ON_KEYS = [27, 9];
function createFactory(identifier, autoCompleteTheme) {
    return function factory(WrappedComponent, options) {
        if (options === void 0) { options = {}; }
        var AutoComplete = /** @class */ (function (_super) {
            tslib_1.__extends(AutoComplete, _super);
            function AutoComplete(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.onDocumentClick = function (e) {
                    var isOpen = _this.state.isOpen;
                    if (isOpen && _this.isClickOutside(e.target)) {
                        _this.close();
                    }
                };
                _this.onWindowScroll = function () {
                    if (_this.state.isOpen) {
                        _this.handlePosition();
                    }
                };
                _this.getItemValue = function (item) {
                    var itemValueKey = _this.props.itemValueKey;
                    return typeof item === "string" ? item : item[itemValueKey];
                };
                _this.getItemLabel = function (item) {
                    var _a = _this.props, itemLabelKey = _a.itemLabelKey, labelFormatter = _a.labelFormatter;
                    var label = typeof item === "string" ? item : item[itemLabelKey];
                    if (labelFormatter) {
                        return labelFormatter(item, label);
                    }
                    return label;
                };
                _this.onChange = function (e) {
                    var onChange = _this.props.onChange;
                    onChange && onChange(e);
                    _this.setState({
                        query: e.target.value
                    });
                };
                _this.onFocus = function (e) {
                    var onFocus = _this.props.onFocus;
                    onFocus && onFocus(e);
                    _this.open();
                };
                _this.onBlur = function (e) {
                    var _a = _this.props, onBlur = _a.onBlur, allowCreate = _a.allowCreate, selectValueOnBlur = _a.selectValueOnBlur, clearInputOnBlur = _a.clearInputOnBlur, allowMultiCreate = _a.allowMultiCreate;
                    var value = e.target.value;
                    if (value && (allowCreate || allowMultiCreate) && selectValueOnBlur && !clearInputOnBlur && !_this.listInteractive) {
                        _this.onListItemsChange(value, value, true);
                    }
                    else if (clearInputOnBlur && !_this.listInteractive) {
                        _this.setState({ isOpen: false });
                        _this.clearQuery();
                    }
                    onBlur && onBlur(e);
                };
                _this.onClick = function (e) {
                    var onClick = _this.props.onClick;
                    _this.open();
                    onClick && onClick(e);
                };
                _this.onKeyUp = function (e) {
                    if ([91, 17].includes(e.keyCode)) {
                        _this.setState({ ctrlKeyDown: false });
                    }
                };
                _this.onKeyDown = function (e) {
                    if (e.metaKey || e.ctrlKey) {
                        _this.setState({ ctrlKeyDown: true });
                    }
                    if (CLOSE_ON_KEYS.indexOf(e.keyCode) > -1) {
                        _this.close();
                        return;
                    }
                    if (e.keyCode === 8 && e.target.value === "") {
                        _this.handleBackspaceKeyOnEmptyQuery();
                        return;
                    }
                    if (!utils_1.isSpecialKeyActive(e)) {
                        _this.open();
                        _this.itemsList && _this.itemsList.onSearchKeyDown(e);
                    }
                };
                _this.onItemsPaste = function (e) {
                    var _a = _this.props, onPaste = _a.onPaste, allowPasteItemsList = _a.allowPasteItemsList, dataSource = _a.dataSource, allowCreate = _a.allowCreate;
                    if (allowPasteItemsList) {
                        var pastedItems = utils_1.trySplitDelimitedString(e.clipboardData.getData("text")).map(function (i) { return i.trim(); });
                        pastedItems.forEach(function (item) {
                            if (item !== "") {
                                var foundItem_1, isNew_1;
                                for (var _i = 0, dataSource_1 = dataSource; _i < dataSource_1.length; _i++) {
                                    var dataSourceItem = dataSource_1[_i];
                                    if (_this.getItemValue(dataSourceItem) === item || _this.getItemLabel(dataSourceItem) === item) {
                                        foundItem_1 = dataSourceItem;
                                        break;
                                    }
                                }
                                if (!foundItem_1 && allowCreate) {
                                    isNew_1 = true;
                                    foundItem_1 = item;
                                }
                                if (foundItem_1) {
                                    setTimeout(function () {
                                        _this.onListItemsChange(_this.getItemValue(foundItem_1), _this.getItemLabel(foundItem_1), isNew_1, isNew_1 ? null : foundItem_1);
                                    });
                                }
                            }
                        });
                    }
                    onPaste && onPaste(e);
                };
                _this.clearQuery = function () {
                    if (!_this.state.ctrlKeyDown) {
                        _this.setState({ query: "" });
                    }
                };
                _this.onListItemsChange = function (value, label, isNew, item) {
                    var _a = _this.props, leaveOpenAfterSelect = _a.leaveOpenAfterSelect, onSelectItem = _a.onSelectItem, name = _a.name;
                    _this.clearQuery();
                    if (!leaveOpenAfterSelect) {
                        _this.close();
                    }
                    if (_this.$input) {
                        _this.$input.focus();
                    }
                    if (onSelectItem) {
                        setTimeout(function () { return onSelectItem(value, label, isNew, name, item); });
                    }
                };
                _this.filter = function (item) {
                    var filter = _this.props.filter;
                    var query = _this.state.query;
                    if (filter) {
                        return filter(item, query);
                    }
                    var itemValue = (_this.getItemValue(item) || "");
                    var itemLabel = (_this.getItemLabel(item) || "");
                    return utils_1.multiWordFilter(itemLabel, query) || utils_1.multiWordFilter(itemValue, query);
                };
                _this.setItemsList = function (component) {
                    _this.itemsList = component;
                };
                _this.onListWrapperMouseDown = function () {
                    _this.listInteractive = true;
                };
                _this.onListWrapperMouseUp = function () {
                    _this.listInteractive = false;
                    if (_this.props.clearInputOnBlur) {
                        setTimeout(function () {
                            _this.clearQuery();
                            _this.setState({ isOpen: false });
                        });
                    }
                };
                _this.setRef = function (el) {
                    _this.$el = el;
                };
                _this.setListRef = function (el) {
                    _this.$list = el;
                };
                _this.setWrappedComponentRef = function (el) {
                    _this.$input = el;
                };
                _this.onSelectAllClick = function () {
                    var _a = _this.props, onSelectAll = _a.onSelectAll, dataSource = _a.dataSource;
                    var query = _this.state.query;
                    var itemsToSelect = dataSource;
                    if (query) {
                        itemsToSelect = dataSource.filter(_this.filter);
                    }
                    onSelectAll(itemsToSelect);
                };
                _this.renderSelectAll = function () {
                    var _a = _this.props, theme = _a.theme, onSelectAll = _a.onSelectAll, dataSource = _a.dataSource;
                    if (!onSelectAll || dataSource.length === 0) {
                        return null;
                    }
                    return (React.createElement("div", { className: theme.footerListButton, onClick: _this.onSelectAllClick },
                        React.createElement(index_1.LinkButton, { type: "button", iconSize: 1.2, bold: true, smaller: true, iconName: "icon-plus-small", blue: true, uppercase: true }, "Select All")));
                };
                _this.listInteractive = false;
                _this.itemsList = null;
                _this.$el = null;
                _this.$list = null;
                _this.$input = null;
                _this.state = { isOpen: false, query: "", cssVertPosition: "top", ctrlKeyDown: false };
                return _this;
            }
            AutoComplete.prototype.getMouseEventMap = function () {
                return {
                    click: this.onDocumentClick
                };
            };
            AutoComplete.prototype.isClickOutside = function (target) {
                return !this.$el.contains(target) && (!this.$list ? true : !this.$list.contains(target));
            };
            AutoComplete.prototype.componentDidMount = function () {
                utils_1.addEventsToDocument(this.getMouseEventMap());
                window.addEventListener("scroll", this.onWindowScroll, { passive: true });
            };
            AutoComplete.prototype.componentWillUnmount = function () {
                utils_1.removeEventsFromDocument(this.getMouseEventMap());
                window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
            };
            AutoComplete.prototype.componentDidUpdate = function (prevProps, prevState) {
                if (this.state.isOpen && !prevState.isOpen) {
                    this.handlePosition();
                }
                if (prevProps.disabled && !this.props.disabled && this.props.focusAfterEnabled) {
                    this.$input && this.$input.focus();
                }
            };
            AutoComplete.prototype.handlePosition = function () {
                var elRect = this.$el.getBoundingClientRect();
                var listRect = this.$list.getBoundingClientRect();
                var nextState = {
                    cssVertPosition: elRect.top + elRect.height + listRect.height > window.innerHeight ? "bottom" : "top"
                };
                if (this.state.cssVertPosition !== nextState.cssVertPosition) {
                    this.setState(nextState);
                }
            };
            AutoComplete.prototype.handleBackspaceKeyOnEmptyQuery = function () {
                var onEmptyQueryBackspaceKey = this.props.onEmptyQueryBackspaceKey;
                onEmptyQueryBackspaceKey && onEmptyQueryBackspaceKey();
            };
            AutoComplete.prototype.open = function () {
                if (!this.state.isOpen) {
                    this.props.onOpen();
                    this.setState({
                        isOpen: true
                    });
                }
            };
            AutoComplete.prototype.close = function () {
                if (this.state.isOpen) {
                    this.props.onClose();
                    this.setState({
                        isOpen: false
                    });
                }
            };
            AutoComplete.prototype.renderSuggestions = function () {
                var _this = this;
                var _a;
                var _b = this.props, theme = _b.theme, isLoading = _b.isLoading, listWidth = _b.listWidth, maxItems = _b.maxItems, value = _b.value, dataSource = _b.dataSource, allowCreate = _b.allowCreate, renderUnderList = _b.renderUnderList, allowMultiCreate = _b.allowMultiCreate, renderList = _b.renderList;
                var _c = this.state, query = _c.query, cssVertPosition = _c.cssVertPosition;
                var displayItems = dataSource;
                if (query) {
                    displayItems = dataSource.filter(this.filter);
                }
                var listStyle = (_a = {},
                    _a[cssVertPosition] = "100%",
                    _a.minWidth = options.fill ? "100%" : "",
                    _a);
                return (React.createElement("div", { className: theme.list, style: listStyle, ref: this.setListRef, onMouseDown: this.onListWrapperMouseDown, onMouseUp: this.onListWrapperMouseUp },
                    renderList ? renderList({
                        allowCreate: allowCreate,
                        allowMultiCreate: allowMultiCreate,
                        maxItems: maxItems,
                        width: listWidth,
                        query: query || value,
                        onListItemsChange: this.onListItemsChange,
                        setItemsList: this.setItemsList,
                        getItemLabel: this.getItemLabel,
                        getItemValue: this.getItemValue,
                        displayItems: displayItems
                    })
                        :
                            React.createElement(itemsList_1.ItemsList, { allowCreate: allowCreate, allowMultiCreate: allowMultiCreate, query: query || value, maxItems: maxItems, onSelectItem: this.onListItemsChange, onRef: this.setItemsList, width: listWidth }, displayItems.map(function (item, idx) { return React.createElement(itemsList_1.ListItem, { key: idx, value: _this.getItemValue(item), label: _this.getItemLabel(item), item: item }); })),
                    this.renderSelectAll(),
                    renderUnderList ? renderUnderList : null));
            };
            AutoComplete.prototype.getListTransitionClasses = function () {
                var theme = this.props.theme;
                return {
                    enter: theme.listEnter,
                    enterActive: theme.listEnterActive,
                    exit: theme.listLeave,
                    exitActive: theme.listLeaveActive
                };
            };
            AutoComplete.prototype.renderLoader = function () {
                var theme = this.props.theme;
                return (React.createElement("div", { className: theme.loaderWrapper },
                    React.createElement(loader_1.CircleLoader, { size: 2, blue: true })));
            };
            AutoComplete.prototype.render = function () {
                var _a = this.props, theme = _a.theme, className = _a.className, isLoading = _a.isLoading, value = _a.value, children = _a.children, allowCreate = _a.allowCreate, allowMultiCreate = _a.allowMultiCreate, selectValueOnBlur = _a.selectValueOnBlur, clearInputOnBlur = _a.clearInputOnBlur, leaveOpenAfterSelect = _a.leaveOpenAfterSelect, dataSource = _a.dataSource, onSelectItem = _a.onSelectItem, maxItems = _a.maxItems, itemValueKey = _a.itemValueKey, itemLabelKey = _a.itemLabelKey, onOpen = _a.onOpen, onClose = _a.onClose, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, filter = _a.filter, onEmptyQueryBackspaceKey = _a.onEmptyQueryBackspaceKey, labelFormatter = _a.labelFormatter, renderUnderList = _a.renderUnderList, renderList = _a.renderList, focusAfterEnabled = _a.focusAfterEnabled, listWidth = _a.listWidth, onSelectAll = _a.onSelectAll, others = tslib_1.__rest(_a, ["theme", "className", "isLoading", "value", "children", "allowCreate", "allowMultiCreate", "selectValueOnBlur", "clearInputOnBlur", "leaveOpenAfterSelect", "dataSource", "onSelectItem", "maxItems", "itemValueKey", "itemLabelKey", "onOpen", "onClose", "onChange", "onFocus", "onBlur", "filter", "onEmptyQueryBackspaceKey", "labelFormatter", "renderUnderList", "renderList", "focusAfterEnabled", "listWidth", "onSelectAll"]);
                var _b = this.state, isOpen = _b.isOpen, query = _b.query;
                var classes = classnames_1.default(theme["auto-complete"], className);
                var wrappedComponentProps = tslib_1.__assign({}, others, { autoComplete: "off", onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onKeyDown: this.onKeyDown, onKeyUp: this.onKeyUp, onClick: this.onClick, onPaste: this.onItemsPaste, value: value || query, exposedRef: this.setWrappedComponentRef });
                return (React.createElement("div", { className: classes, ref: this.setRef },
                    React.createElement(WrappedComponent, tslib_1.__assign({}, wrappedComponentProps)),
                    isLoading ? this.renderLoader() : null,
                    React.createElement(react_transition_group_1.CSSTransition, { in: isOpen, unmountOnExit: true, classNames: this.getListTransitionClasses(), timeout: 200 }, this.renderSuggestions())));
            };
            AutoComplete.defaultProps = {
                allowCreate: false,
                allowMultiCreate: false,
                leaveOpenAfterSelect: false,
                allowPasteItemsList: false,
                dataSource: [],
                itemValueKey: "value",
                itemLabelKey: "label",
                onOpen: utils_1.noop,
                onClose: utils_1.noop
            };
            return AutoComplete;
        }(React.Component));
        return react_css_themr_1.themr(identifier, autoCompleteTheme)(AutoComplete);
    };
}
exports.default = createFactory;
